import { render, staticRenderFns } from "./itemSettingPage.vue?vue&type=template&id=2f664e95&"
import script from "./itemSettingPage.vue?vue&type=script&lang=ts&"
export * from "./itemSettingPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports